/**
 * Hidden form fields for the A2A consent flow.
 *
 * Passes the scopes from the consent token as the selected scopes
 * for the form submission.
 */

import { useToken } from '../../Flow/ConsentContextProvider';

const A2A_REQUIRED_SCOPES = ['read:me', 'offline_access'];

const A2AFlowParameters = () => {
  const { scopes } = useToken();

  const allScopes = [...new Set([...scopes, ...A2A_REQUIRED_SCOPES])];

  return (
    <input
      type="hidden"
      name="selectedScopes"
      value={allScopes.join(' ')}
    />
  );
};

export default A2AFlowParameters;
